import React, { createContext, useContext, useState, useEffect } from 'react';
import { tenantsAPI } from './api';

const TenantContext = createContext(null);

export function TenantProvider({ children }) {
  const [tenants, setTenants] = useState([]);
  const [selectedTenant, setSelectedTenant] = useState(() => {
    // persist ke localStorage supaya tidak hilang saat refresh
    const saved = localStorage.getItem('selectedTenantId');
    return saved ? +saved : '';
  });

  useEffect(() => {
    tenantsAPI.list({ per_page: 100, status: 'active' })
      .then(r => {
        const list = r.tenants || [];
        setTenants(list);
        // kalau belum ada pilihan, auto-select tenant pertama
        setSelectedTenant(prev => {
          if (!prev && list.length > 0) return list[0].id;
          return prev;
        });
      }).catch(() => {});
  }, []);

  const selectTenant = (id) => {
    setSelectedTenant(id);
    if (id) localStorage.setItem('selectedTenantId', id);
    else localStorage.removeItem('selectedTenantId');
  };

  const currentTenant = tenants.find(t => t.id === selectedTenant) || null;

  return (
    <TenantContext.Provider value={{ tenants, selectedTenant, selectTenant, currentTenant }}>
      {children}
    </TenantContext.Provider>
  );
}

export function useTenant() {
  return useContext(TenantContext);
}